import { render, staticRenderFns } from "./CompraSperidian.vue?vue&type=template&id=2063b0dd&"
import script from "./CompraSperidian.vue?vue&type=script&lang=js&"
export * from "./CompraSperidian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports